import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { groupBy, GroupResult } from '@progress/kendo-data-query';
import {
  QPointCheckboxListComponent,
  QPointReactiveFormInputGroupComponent,
  QPointSuggestlistDetailTemplateDirective,
  QPointSuggestListGroupTemplateDirective,
} from '@qpoint/forms';

import {
  DropDownVariant,
  QPointSuggestlistComponent,
} from '../../../../../projects/qpoint-forms/src/lib/suggestlist/suggestlist.component';

interface IDummyItem {
  key: string;
  value: string;
  group: string;
}

@Component({
    selector: 'app-control-gallery-suggest-list',
    templateUrl: './suggest-list.component.html',
    imports: [
        FormsModule,
        QPointSuggestlistComponent,
        QPointReactiveFormInputGroupComponent,
        ReactiveFormsModule,
        QPointCheckboxListComponent,
        QPointSuggestlistDetailTemplateDirective,
        QPointSuggestListGroupTemplateDirective
    ]
})
export class ControlGallerySuggestListComponent {
  items: IDummyItem[] = [];
  groupedItems: GroupResult[] | IDummyItem[];
  filteredItems: IDummyItem[] = [];
  disabled = false;
  readonly = false;
  loading = false;
  value = null;
  defaultItem: IDummyItem = { key: null, value: null, group: null };

  suggestListFormControl = new UntypedFormControl(null, [Validators.required]);

  public dropDownVariant = DropDownVariant;

  constructor() {
    this.items = [];

    for (let i = 0; i < 50; i++) {
      this.items.push({
        key: `item-${i}`,
        value: `This is item ${i}`,
        group: i % 2 === 0 ? 'Even' : 'Odd'
      });
    }

    const groupedItems = [];
    for (let i = 0; i < 20; i++) {
      groupedItems.push({
        key: `item-${i}`,
        value: `This is item ${i} - ${i % 2 === 0 ? 'Even' : 'Odd'}`,
        group: i % 2 === 0 ? 'Even' : 'Odd'
      });
    }

    this.groupedItems = groupBy(this.items, [{ field: 'group' }] );

    this.filteredItems = [...this.items];
  }

  onChange($event) {
    this.value = $event;
  }

  setToPreselection() {
    this.value = {'key': 'item-40', 'value': 'This is item 40'};
  }

  setToNonExisting() {
    requestAnimationFrame(() => this.value = {'key': 'item----', 'value': 'This is item ----'});
  }

  setToNewItems() {
    this.items = [...this.items];
  }

  public suggestListFilterChanged($event) {
    this.filteredItems = this.items.filter(item => item.value.toLowerCase().includes($event.toLowerCase()));
  }
}
